import React, { Component } from 'react';
import ModalForm from '../../comum/components/ModalForm';
import { Button, Row, Col, Label } from 'reactstrap';
import FormInputSimples from '../../comum/components/FormInputSimples';
import { toast } from "react-toastify";
import lscache from "lscache";
import { inject, observer } from 'mobx-react';

@inject("store")
@observer
export default class ModalPalavraChave extends Component {
    constructor(props) {
        super(props);

        this.modalStore = this.props.store.modalStore;
        this.loginStore = this.props.store.loginStore;
        this.controller = this.props.controller;

        this.state = {
            abaAtiva: 'celular'
        };

        const dddCache = lscache.get('Ddd');
        const PhoneCache = lscache.get('Phone');

        if(dddCache){
            this.loginStore.setDDD(dddCache);
            this.loginStore.setCelular(PhoneCache);
        }
    }

    SalvarCelular = async () => {
        const sucesso = await this.loginStore.salvarCelularUsuario();

        const error = !sucesso ? this.loginStore.msgCelular : null;

        const title = !error ? "Salvo com sucesso!" : "Erro ao salvar!";
        const message = error ? error : "Seu número de celular foi atualizado com sucesso.";

        if(!error){
            toast.success(title, {
                  position: "top-right",
                  autoClose: 2000,
                  hideProgressBar: false,
                  closeOnClick: true,
                  pauseOnHover: true
                })
            this.loginStore.fecharModalPalavraChave();
        }
        else{
            const errorMesage = title + "\n" + message;
            toast.error(errorMesage, {
                  position: "top-right",
                  autoClose: 2000,
                  hideProgressBar: false,
                  closeOnClick: true,
                  pauseOnHover: true
                })
        }
    };


    renderAbas() {
        const { abaAtiva } = this.state;

        return (
            <Row className="mb-3 justify-content-center">              
                <Label
                    color={abaAtiva === 'celular' ? 'primary' : 'secondary'}
                    className={`${abaAtiva !== 'celular' ? 'btn-secondary-dark' : ''}`}
                >
                    Atualizar Celular
                </Label>
            </Row>
        );
    }   

    renderCelular() {
        return (
            <div className="login--container">
                <h2 className="title-black">Atualizar celular</h2>
                <Label className="login--form-label label-tight">
                    Mantenha seu número atualizado para receber o token de validação.
                </Label>

                <Row>
                    <Col style={{marginTop : 30}}>
                        <FormInputSimples
                            inputClassName="noneCase"
                            type="text"
                            titulo="DDD"
                            xl={12} lg={12} md={12} sm={12} xs={12}
                            dado={this.loginStore.ddd}
                            obrigatorio={true}
                            limiteMaximo={2} 
                            placeholder='XX'
                            onChange={(e) => {
                                let value = e.target.value.replace(/\D/g, '');
                                value = value.slice(0, 2);
                                this.loginStore.setDDD(value);
                            }}
                        />
                    </Col>
                </Row>

                <Row>
                    <Col>
                        <FormInputSimples
                            inputClassName="noneCase"
                            type="text"
                            titulo="Número de Celular"
                            xl={12} lg={12} md={12} sm={12} xs={12}
                            dado={this.loginStore.celular}
                            obrigatorio={true}
                            limiteMaximo={10}
                            placeholder='XXXXXXXXXX'
                            onChange={(e) => {
                                let value = e.target.value.replace(/\D/g, '');
                                value = value.slice(0, 10); 
                                this.loginStore.setCelular(value);
                            }}
                        />
                    </Col>
                </Row>
            </div>
        );
    }

    render() {
        return (
            <ModalForm
                className="tamanho-modal-500"
                labelConfirmar="SALVAR"
                labelCancelar="CANCELAR"
                onClickSalvar={() => this.SalvarCelular()}
                onClickCancelar={() => this.loginStore.fecharModalPalavraChave()}
            >
                {this.renderCelular()}
            </ModalForm>
        );
    }
}


// WEBPACK FOOTER //
// ./src/modules/login/components/ModalPalavraChave.js